module.exports = __webpack_public_path__ + "static/media/10.f635b220.jpg";